<div class="section-header">
    <div class="title">
        Ausschreibungsdokumente
    </div>
</div>

<div [ngClass]="{'notify-change' : notifyChange( pUNFEnum.TENDER_DOCUMENTS)}">
    <div class="documents-container" *ngIf="model.project?.tenderDocuments?.length else noDocuments">
        <div class="document" *ngFor="let document of model.project.tenderDocuments" (click)="onDocumentClicked( document )"  >
            <bd-fa [name]="'download'"></bd-fa>  {{document.fileName}}
        </div>
    </div>

    <ng-template #noDocuments>
        <div class="no-doc-info">
            Keine Ausschreibungsdokumente vorhanden
        </div>
    </ng-template>
</div>

